module.exports = __webpack_public_path__ + "img/ministerio-consumo.a5131f6f.svg";